/*global window*/
angular.module('mtic')
.config(function ($locationProvider, DEV_VARIABLES, $provide, $logProvider, tooltipsConfProvider) {
  
  $locationProvider.hashPrefix('');
  
  // disable logging
  if(!DEV_VARIABLES.LOGGING_OVERRIDE.GENERAL) {
    $logProvider.debugEnabled(/localhost/.test(window.location.hostname));
  }
  // turn off automatic tracking
  // $analyticsProvider.virtualPageviews(false);
  // tooltip config
  tooltipsConfProvider.configure({
    'smart': true,
    'size': 'large',
    'speed': 'slow',
    'class': 'tooltip-main-class'
  });
});
